define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/TagModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext, TagModel) {
    "use strict";
    var Tag = /** @class */ (function () {
        function Tag() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,Tag.Edit,Tag.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,Tag.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new TagModel());
        }
        Tag.prototype.init = function () {
            var self = this;
            $("#page-title").text("Tags");
            tools.ajaxGet({
                url: "/Tag/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.lookupLists.GridStructures.TagStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Tag.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblTagKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.tagsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Tag/GetTags",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#tags-toolbar-template").html()),
                    columns: columns
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "Tag",
                    title: "Tags",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.tagsTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.tagsTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editTag(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteTagConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        Tag.prototype.editTag = function (id) {
            var self = this;
            var title = "Add New Tag";
            if (!isNaN(id)) {
                title = "Edit Tag";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Tag name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveTag(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Tag/GetTagById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new TagModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new TagModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'tag-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        Tag.prototype.saveTag = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Tag/SaveTag",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.tagsTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        Tag.prototype.deleteTag = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Tag/DeleteTagConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Tag deleted successfully");
                    self.tagsTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        Tag.prototype.deleteTagConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Tag",
                text: "Are you sure you want to delete product tag " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteTag(id);
            });
        };
        return Tag;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Tag/Index")) {
            log.log("Initialize Tags list ...");
            $(function () {
                (new Tag()).init();
            });
        }
    }, 0);
    return Tag;
});
//# sourceMappingURL=tags.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/tags/tags.js
// module id = 314
// module chunks = 2